<template>
  <div id="app" style="background-color: #fff !important;" :class="isEN ? 'dir-ltr' : 'dir-rtl'">
    <v-app style="transform: scale(0.9) !important;">
      <Header v-if="$route.meta.header"/>
      <router-view/>
      <Footer v-if="$route.meta.footer"/>
    </v-app>
    <div class="podcast" role="button" @click="oracle.openLink(podcast)"
         v-if="podcast_image != null && podcast != null && podcast.length > 0">
      <img alt="" class="hover-poster" :src="podcast_image"/>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import oracle from "@/oracle";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  }, beforeCreate() {
    if (oracle.isMobile()) {
      window.location.href = 'https://pwa.cluna.app'
    }
  }, mounted() {
    oracle.axios('setting/getInfo', {filter_by: "website", search_by: 'podcast'}, (response) => {
      if (response.data != null && response.data.length > 0) {
        oracle.axios('setting/getInfo', {filter_by: "website", search_by: 'podcast_image'}, (poster) => {
          this.podcast = response.data
          this.podcast_image = poster.data
        })
      }
    })
  }, data: () => ({
    oracle: oracle,
    podcast: null,
    podcast_image: null,
    isEN: oracle.isEN()
  })
};
</script>
<style>

@font-face {
  font-family: Vazirmatn;
  src: url('~@/assets/font/vazir/webfonts/Vazirmatn-FD-NL-Thin.woff2') format('woff2');
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: Vazirmatn;
  src: url('~@/assets/font/vazir/webfonts/Vazirmatn-FD-NL-ExtraLight.woff2') format('woff2');
  font-weight: 200;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: Vazirmatn;
  src: url('~@/assets/font/vazir/webfonts/Vazirmatn-FD-NL-Light.woff2') format('woff2');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: Vazirmatn;
  src: url('~@/assets/font/vazir/webfonts/Vazirmatn-FD-NL-Regular.woff2') format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: Vazirmatn;
  src: url('~@/assets/font/vazir/webfonts/Vazirmatn-FD-NL-Medium.woff2') format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: Vazirmatn;
  src: url('~@/assets/font/vazir/webfonts/Vazirmatn-FD-NL-SemiBold.woff2') format('woff2');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: Vazirmatn;
  src: url('~@/assets/font/vazir/webfonts/Vazirmatn-FD-NL-Bold.woff2') format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: Vazirmatn;
  src: url('~@/assets/font/vazir/webfonts/Vazirmatn-FD-NL-ExtraBold.woff2') format('woff2');
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: Vazirmatn;
  src: url('~@/assets/font/vazir/webfonts/Vazirmatn-FD-NL-Black.woff2') format('woff2');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 600 1000;
  font-display: swap;
  src: url('~@/assets/font/nunito/XRXV3I6Li01BKofIO-aBTMnFcQIG.woff2') format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

@font-face {
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 600 1000;
  font-display: swap;
  src: url('~@/assets/font/nunito/XRXV3I6Li01BKofINeaBTMnFcQ.woff2') format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

* {
  letter-spacing: 0 !important;
}

html {
  background-color: #fff !important;
}

body {
  background-color: #fff !important;
}

.center-cropped {
  background-position: center center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  object-position: center center !important;
  object-fit: cover !important;
  overflow: hidden !important
}

h1, h2, h3, h4, h5, h6, span {
  color: black;
}

.v-application ol, .v-application ul {
  padding-left: unset !important;
}

.v-overlay__scrim {
  background-color: transparent !important;
}

.swal2-popup {
  padding-top: 50px;
  padding-bottom: 50px;
}

.swal2-container {
  z-index: 30000 !important;
}

.v-dialog__content {
  z-index: 3000 !important;
}

.swal-overlay {
  z-index: 30000 !important;
}

.v-application--wrap {
  background-color: #fff !important;
  height: 100vh;
  min-height: unset !important;
}

*:focus {
  box-shadow: none !important;
  border: none !important;
  outline: none !important;
}

button:focus,
input:focus,
textarea:focus {
  box-shadow: none !important;
  border: none !important;
  outline: none !important;
}

button {
  letter-spacing: 0 !important;
}

a:hover {
  text-decoration: none !important;
}

ul,
ol {
  margin: 0 !important;
  padding: 0;
  list-style: none;
}

.noSpace {
  margin: 0 !important;
  padding: 0 !important;
}

.multi-line {
  white-space: pre-wrap;
}

.swal2-html-container p {
  font-size: 13px !important;
}

.swal2-image {
  width: 50px !important;
  height: 50px !important;
}

.swal2-confirm {
  background-color: #7dc353 !important;
  width: 60%;
  font-size: 13px !important;
}

a {
  text-decoration: none;
}

.podcast {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 20;
}

.podcast img {
  height: 60px;
  width: auto;
  max-height: 60px;
  min-height: 60px;
}

.hover-poster {
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px;
  transition: all .3s ease-in-out;
}

.hover-poster:hover {
  box-shadow: rgba(0, 0, 0, 0.22) 0px 19px 43px;
  transform: translate3d(0px, -1px, 0px);
}
</style>

<style lang="scss">
@import "./assets/directions.scss";
</style>